<template>
    <f7-page name="vodne-stavy-chart" @page:init="onPageInit">
        <f7-navbar>
            <f7-nav-left>
                <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
            </f7-nav-left>
            <f7-nav-title sliding>{{ pageTitle }}</f7-nav-title>
            <f7-nav-right>
                <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
                <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
            </f7-nav-right>
        </f7-navbar>

        <template v-if="notEmptyObject(stationDataForChart)">
            <f7-block v-if="stationDataForChart.station.graph_text" strong class="no-margin fs-075 text-align-center padding-half">
                {{ stationDataForChart.station.graph_text }}
            </f7-block>
            <highcharts ref="vtHighcharts" :updateArgs="[true, true, true]" :options="chartOptions"></highcharts>

        </template>

    </f7-page>
</template>
<script>
    import Axios from "axios";
    import SHMUconf from "../js/SHMUconf";
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts';

    import vtChart from './vodne-stavy-chart-options'

    Highcharts.setOptions({
        lang: {
            weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
            shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
            months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
        },
        global: {
            useUTC: true
        }
    });


    export default {
        components: {
            highcharts: Chart
        },
        data: function () {
            return {
                pageTitle: 'Vodný stav',
                stationIdForChart: null,
                stationDataForChart: {},
                chartOptions: vtChart,
            };
        },
        watch: {
            stationDataForChart() {
                this.generateChart()
            }
        },
        mounted() {
            const self = this;
            // otvorime hlavne menu
            this.$f7.accordion.close('.shmu-i-vodne-zdroje');
            this.$f7.accordion.open('.shmu-i-vodne-zdroje');
        },
        destroy() {
            clearInterval(this.tCheckInterval);
            this.stationIdForChart = null;
            this.stationDataForChart = {};
        },
        methods: {
            onPageInit() {
                this.stationIdForChart = parseInt(this.$f7route.params.station_id);
                this.pageReload(null, true);
            },
            pageReload(event, isInit) {
                const self = this;

                if (this.stationIdForChart && (isInit || (this.$moment().unix() - this.lastUpdated) > 60)) {
                    this.loadHistoryData(this.stationIdForChart);
                } else {
                    if (!this.stationIdForChart) {
                        self.$f7.dialog.alert('Identifikátor stanice nebol správne určený!', 'Nastala chyba');
                    }
                }
            },
            loadHistoryData(station_id) {
                const self = this;

                self.$f7.dialog.preloader('Načítavam...');
                Axios.get(SHMUconf.API_BASE_URL + 'hydro/getvthistorydata?station='+station_id+'&history=120', {
                    crossDomain: true,
                    cache: false,
                })
                    .then((response) => {
                        if (!response.data.error) {
                            self.stationDataForChart = response.data;
                            self.pageTitle = self.stationDataForChart.station.station_name + ' - ' + self.stationDataForChart.station.river_name + ' - Vodné stavy ';
                            self.lastUpdated = self.$moment().unix();
                            // clearInterval(this.tCheckInterval);
                            // this.tCheckInterval = setInterval(this.checkLastUpdated, 5 * 60 * 1000); // overujem kazdych 5 min
                        } else {
                            self.$f7.dialog.alert('Nepodarilo sa načítať údaje pre vykreslenie grafu', 'Nastala chyba');
                        }
                        self.$f7.dialog.close();
                    }).catch((error) => {
                    self.$f7.dialog.close();
                    self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
                });

            },
            checkLastUpdated() {
                if ((this.$moment().unix() - this.lastUpdated) >= 2*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
                    this.pageReload(null, false);
                }
            },
            generateChart() {
                // console.log(e);

                let measured = [];
                let forecast = [];
                let vals = [];
                // priprav data pre chart
                if (this.stationDataForChart.measured) {
                    this.stationDataForChart.measured.forEach((item) => {


                      // donutenie ho zobrazovat SEC/LSEC casy na grafe
                      let m_f = this.$moment.unix(item.dt).tz('Europe/Bratislava').utc().format();
                      let m = this.$moment(m_f);
                      let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());

                      // measured.push([item.dt * 1000, item.hladina]);
                      measured.push([d, item.hladina]);

                        if (item.hladina !== null) {
                            vals.push(item.hladina);
                        }
                    });
                }
                if (this.stationDataForChart.forecast) {
                    this.stationDataForChart.forecast.forEach((item) => {

                      // donutenie ho zobrazovat SEC/LSEC casy na grafe
                      let m_f = this.$moment.unix(item.dt).tz('Europe/Bratislava').utc().format();
                      let m = this.$moment(m_f);
                      let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());

                      forecast.push([d, item.hladina]);
                        //forecast.push([item.dt * 1000, item.hladina]);
                        if (item.hladina !== null) {
                            vals.push(item.hladina);
                        }
                    });
                }


                let cor = 0;
                let max_value = 0;
                let min_value = 0;
                let spa3 = this.stationDataForChart.station.spa3;
                if (spa3 !== null) {
                    if (spa3 > 100) cor = 5;
                    if (spa3 > 300) cor = 10;
                    if (spa3 > 500) cor = 20;
                    if (spa3 > 700) cor = 30;
                }

                // MIN MAX VALUES
                if (vals.length > 0) {
                    min_value = Math.min.apply(null, vals);
                    max_value = Math.max.apply(null, vals);

                    if (max_value > 0) {
                        max_value += Math.round((max_value * 0.2));
                    } else {
                        max_value += Math.round((Math.abs(max_value) * 0.2));
                    }
                    if (min_value < 0) {
                        min_value -= Math.round((Math.abs(min_value) * 0.2));
                    } else {
                        min_value = 0;
                    }
                } else {
                    if (spa3 !== null) {
                        max_value = spa3 + cor;
                    } else {
                        max_value = cor;
                    }
                }

                if (spa3 !== null) {
                    if (max_value <= spa3) max_value = spa3 + cor;
                }

                if (spa3 === null)
                {
                    if (this.stationDataForChart.station.max_hlbka_toku !== null && max_value !== 0) {
                        if (max_value < this.stationDataForChart.station.max_hlbka_toku) {
                            max_value = this.stationDataForChart.station.max_hlbka_toku;
                        }
                    }
                }

                let max_value_check = 0;
                let minor_tick = 5;
                let normal_tick = 10;
                if (min_value < 0) max_value_check = Math.abs(min_value);
                else max_value_check = max_value;

                if (max_value_check > 500) { minor_tick = 25; normal_tick = 50; }
                else if (max_value_check > 200) { minor_tick = 10; normal_tick = 20; }
                else if (max_value_check > 50) { minor_tick = 5; normal_tick = 10; }
                else if (max_value_check > 0) { minor_tick = 1; normal_tick = 5; }

                this.chartOptions.yAxis[0].min = min_value;
                this.chartOptions.yAxis[0].max = max_value;
                this.chartOptions.yAxis[0].normalTick = normal_tick;
                this.chartOptions.yAxis[0].minorTick = minor_tick;

                //E:MIN MAX

                if (this.stationDataForChart.station.spa1 === null) {
                    this.chartOptions.series.find(item => (item.id) === 'spa1').showInLegend = false;
                    this.chartOptions.series.find(item => (item.id) === 'spa2').showInLegend = false;
                    this.chartOptions.series.find(item => (item.id) === 'spa3').showInLegend = false;
                    this.chartOptions.yAxis[0].plotBands = [];

                } else {
                    this.chartOptions.series.find(item => (item.id) === 'spa1').showInLegend = true;
                    this.chartOptions.series.find(item => (item.id) === 'spa2').showInLegend = true;
                    this.chartOptions.series.find(item => (item.id) === 'spa3').showInLegend = true;

                    let label1 = 'SPA 1: ' + this.stationDataForChart.station.spa1 + 'cm';
                    let label2 = 'SPA 2: ' + this.stationDataForChart.station.spa2 + 'cm';
                    let label3 = 'SPA 3: ' + this.stationDataForChart.station.spa3 + 'cm';

                    let myPlogBands = [
                        { label: {text: label1, verticalAlign: 'bottom', style: {color: "rgba(117,117,16,0.65)", fontSize:'9px', 'transform': 'translate(0,-10px)'}}, color: "rgba(255, 255, 0, 0.65)", to: this.stationDataForChart.station.spa2, from: this.stationDataForChart.station.spa1},
                        { label: {text: label2, verticalAlign: 'bottom', style: {color: "rgba(134,83,4,0.65)", fontSize:'9px', 'transform': 'translate(0,-10px)'}}, color: "rgba(255, 153, 0, 0.65)", to: this.stationDataForChart.station.spa3, from: this.stationDataForChart.station.spa2},
                        { label: {text: label3, verticalAlign: 'bottom', style: {color: "rgba(165,3,3,0.65)", fontSize:'9px', 'transform': 'translate(0,-10px)'}}, color: "rgba(255, 31, 0, 0.65)", to: this.stationDataForChart.station.spa3*100, from: this.stationDataForChart.station.spa3}];
                    this.chartOptions.yAxis[0].plotBands = myPlogBands;
                }

                this.chartOptions.subtitle.text = this.stationDataForChart.station.station_name + ' - ' + this.stationDataForChart.station.river_name + ' ('+this.stationDataForChart.station.id_station+')';

                let m1 = this.chartOptions.series.find(item => (item.id) === 'm');
                m1.data = measured;
                if (forecast.length > 0) {
                    let m2 = this.chartOptions.series.find(item => (item.id) === 'f');
                    m2.data = forecast;
                    m2.showInLegend = true;
                } else {
                    let m2 = this.chartOptions.series.find(item => (item.id) === 'f');
                    m2.data = [];
                    m2.showInLegend = false;
                }

            },


        }

    };
</script>

<style lang="scss">



</style>
